import React, { useEffect, useState } from "react";
import "./siView.scss";
import CustomCreatableMultiSelect from "../../common/CustomCreatableMultiSelect";
import useDebounce from "../../common/debounce";
import { investigationAndNotesSearch } from "../../ERXViewApiHandler";
import {
  GET_INSTRUCTION_SEARCH_TERMS,
  GET_INVESTIGATION_SEARCH_TERMS,
  SAVE_CUSTOM_INSTRUCTION_AND_NOTES,
} from "../../ERXViewApiHandler/apiConstants";
import TitleWithBorder from "../../common/TitleWithBorder";
import { CUSTOM_BUTTON_STATUS } from "../../ERXConstants/constants";
import { LOCALSTORAGEKEY } from "../../../../Util/Helper/localStorageUtils";
import { c2cPostApiHandler } from "../../../../Util/c2cApiHandler";

const SIView = (props) => {
  const {
    element,
    followUp,
    prescription_id,
    handleFollowUp,
    handleUpdateAPICall,
    instructionSuggestionList,
  } = props;
  const [maxApiCall, setMaxApiCall] = useState(1);
  const [pageNo, setPageNo] = useState(1);
  const [instructionSuggestionArr, setInstructionSuggestionArr] = useState([]);
  const debounceForFollowUp = useDebounce(followUp, 500);

  const userId = localStorage.getItem(LOCALSTORAGEKEY.USER_ID);
  // <=== Life Cycle

  useEffect(() => {
    if (debounceForFollowUp?.call_api) {
      handleUpdateAPICall();
    }
  }, [debounceForFollowUp]);

  useEffect(() => {
    if (instructionSuggestionList?.length > 0) {
      let data = [...followUp?.value];
      let instructionIndex = data.findIndex(
        (value) => value.name === "instructions_and_notes"
      );
      if (instructionIndex > -1) {
        instructionSuggestionList.forEach((item) => {
          let filterData = data[instructionIndex]?.value?.filter(
            (filterDataValue) =>
              filterDataValue.value.toLowerCase() === item.title.toLowerCase()
          );
          item.selected = filterData?.length !== 0;
        });
        setInstructionSuggestionArr([...instructionSuggestionList]);
      }
    }
  }, [instructionSuggestionList, followUp]);

  // ===>

  // <== API
  const getAPIEndPoint = (endPointKey) => {
    let api = "";
    if (endPointKey === "suggested_investigation") {
      api = GET_INVESTIGATION_SEARCH_TERMS;
    } else if (endPointKey === "instructions_and_notes") {
      api = GET_INSTRUCTION_SEARCH_TERMS;
    }
    return api;
  };

  const getInvestigationAndNotes = async (
    key,
    searchString,
    investigationPageNo,
    type
  ) => {
    let reqParams = {
      search_string: searchString,
      page_no: investigationPageNo,
      doctor_id: userId,
    };
    const response = investigationAndNotesSearch(
      getAPIEndPoint(key),
      reqParams
    );
    response.then(([res, count, error]) => {
      let data = [...followUp.value];
      let index = data.findIndex(
        (dataIndexValue) => dataIndexValue.name === key
      );
      if (!error) {
        if (res?.length > 0) {
          if (index > -1) {
            if (type === "search") {
              data[index].options = [...res];
            } else {
              data[index].options = [...data[index].options, ...res];
            }

            data[index].menuIsOpen = true;
            let maxCount = Math.ceil(count / 20);
            setMaxApiCall(maxCount);
            if (key === "instructions_and_notes") {
              if (data[index]?.options?.length > 0) {
                let indexKey = data[index].value.findIndex(
                  (item) =>
                    item?.value?.trim()?.toLowerCase() ===
                    data[index]?.options[0]?.value?.trim()?.toLowerCase()
                );
                if (indexKey > -1) {
                  if (data[index]?.options[0]?.knowledge_base_id) {
                    data[index].value[indexKey].knowledge_base_id =
                      data[index]?.options[0].knowledge_base_id;
                    data[index].value[indexKey].button_status = "";
                  } else if (data[index]?.options[0]?.master_id) {
                    data[index].value[indexKey].master_id =
                      data[index]?.options[0].master_id;
                    data[index].value[indexKey].button_status = "";
                  } else {
                    data[index].value[indexKey].button_status =
                      CUSTOM_BUTTON_STATUS.SAVE;
                  }
                }
              }
            }
            handleFollowUp(true, [...data]);
          }
        } else {
          data[index].options = [];
          data[index].menuIsOpen = false;
          handleFollowUp(true, [...data]);
        }
      } else {
        data[index].options = [];
        data[index].menuIsOpen = false;
        handleFollowUp(true, [...data]);
      }
    });
  };

  // ==>

  // <== Actions

  const handleSearch = (key, value, pageno, type) => {
    if (value?.length > 0) {
      getInvestigationAndNotes(key, value, pageno, type);
    } else {
      setMaxApiCall(0);
      setPageNo(1);
      let data = [...followUp.value];
      let index = data.findIndex(
        (dataIndexValue) => dataIndexValue.name === key
      );
      if (index > -1) {
        data[index].options = [];
        data[index].menuIsOpen = false;
        handleFollowUp(true, [...data]);
      }
    }
  };

  const handleSelect = (key, value) => {
    let data = [...followUp.value];
    let index = data.findIndex((dataIndexValue) => dataIndexValue.name === key);
    let isValueDuplicate = data[index].value.filter(
      (ele) =>
        ele.value?.trim()?.toLowerCase() === value?.value?.trim()?.toLowerCase()
    );
    if (index > -1) {
      if (data[index].value.length > 0) {
        if (isValueDuplicate.length === 0) {
          value["id"] = data[index].value[data[index].value.length - 1].id + 1;
        }
      } else {
        value["id"] = 1;
      }
      if (value?.id) {
        data[index].options = [];
        data[index].value = [...data[index].value, value];
        data[index].menuIsOpen = false;
        handleFollowUp(true, [...data]);
      }
    }
  };

  const handleOnChange = (key, value) => {
    let data = [...followUp.value];
    let index = data.findIndex((dataIndexValue) => dataIndexValue.name === key);
    if (index > -1) {
      data[index].options = [];
      data[index].menuIsOpen = false;
      data[index].value = value;
      handleFollowUp(true, [...data]);
    }
  };

  const handleCustomInput = (keyName, value) => {
    let obj = {
      ...value,
      title: value?.value,
      ...(keyName === "instructions_and_notes" && {
        button_status:
          value?.knowledge_base_id || value?.master_id
            ? ""
            : CUSTOM_BUTTON_STATUS.SAVE,
      }),
    };
    handleSelect(keyName, obj);
  };

  const handleSuggestionClick = (suggestion, name) => {
    if (!suggestion?.selected) {
      let data = [...followUp.value];
      let index = data.findIndex(
        (dataIndexValue) => dataIndexValue.name === name
      );

      if (index > -1) {
        let isValueDuplicate = data[index]?.value?.filter(
          (ele) =>
            ele?.value?.trim()?.toLowerCase() ===
            suggestion?.title?.toLowerCase()
        );
        let id = null;
        if (data[index]?.value?.length > 0) {
          if (isValueDuplicate.length === 0) {
            id = data[index]?.value[data[index]?.value?.length - 1].id + 1;
          }
        } else {
          id = 1;
        }
        if (id) {
          let obj = {
            id: id,
            value: suggestion?.title,
            ...(suggestion?.slug && { slug: suggestion?.slug }),
            ...(suggestion?.master_id && { master_id: suggestion?.master_id }),
            ...(suggestion?.knowledge_base_id && {
              knowledge_base_id: suggestion?.knowledge_base_id,
            }),
          };
          handleCustomInput(name, obj);
        }
      }
    }
  };

  const handleSaveCustomData = (name, id) => {
    let data = [...followUp.value];
    let index = data.findIndex(
      (dataIndexValue) => dataIndexValue.name === name
    );
    if (index > -1) {
      let dataIndex = data[index].value.findIndex(
        (key_name) => key_name.id === id
      );
      data[index].value[dataIndex].button_status = CUSTOM_BUTTON_STATUS.LOADING;
      handleFollowUp(true, [...data]);
      let requestPayload = {
        "authorizer-principal-id": { user_type: "1" },
        prescription_id: prescription_id,
        doctor_id: userId,
        title: data[index].value[dataIndex].title,
      };
      const saveCustomDataResponse = c2cPostApiHandler(
        SAVE_CUSTOM_INSTRUCTION_AND_NOTES,
        requestPayload
      ); //Fetch API Data
      saveCustomDataResponse.then(([res, error]) => {
        if (!error) {
          if (res?.data?.statusCode === 200) {
            let responseData = { ...res?.data };
            setTimeout(() => {
              data[index].value[dataIndex]["knowledge_base_id"] =
                responseData?.knowledge_base_id;
              data[index].value[dataIndex].button_status =
                CUSTOM_BUTTON_STATUS.SUCCESS;
              handleFollowUp(true, [...data]);
            }, 2000);
          } else {
            triggerErrorLoader(name, id);
          }
        } else {
          triggerErrorLoader(name, id);
        }
      });
    }
  };

  const triggerErrorLoader = (name, id) => {
    let data = [...followUp.value];
    let index = data.findIndex(
      (dataIndexValue) => dataIndexValue.name === name
    );
    if (index > -1) {
      let dataIndex = data[index].value.findIndex(
        (dataIndexValue) => dataIndexValue.id === id
      );
      data[index].value[dataIndex].button_status = CUSTOM_BUTTON_STATUS.ERROR;
      handleFollowUp(true, [...data]);
      setTimeout(() => {
        data[index].value[dataIndex].button_status = CUSTOM_BUTTON_STATUS.SAVE;
        handleFollowUp(true, [...data]);
      }, 2000);
    }
  };

  // ==>

  // <== UI

  const renderSuggestionUI = (name) => {
    return (
      <div className="suggestion-container">
        {instructionSuggestionArr.map((data, index) => (
          <div className="suggestion-wrapper" key={index}>
            <TitleWithBorder
              key={index}
              title={data?.title}
              selected={data?.selected}
              hoverTitleSize={30}
              handleClick={() => handleSuggestionClick(data, name)}
            />
          </div>
        ))}
      </div>
    );
  };
  const suggestedInvestigationAndNotes = () => {
    return (
      <div id={element.name} className="pfu-suggested-investigation">
        <div className="mt-0">
          {followUp.value.map((data, ind) => (
            <div
              key={ind}
              className={
                "pfu-components " +
                (data.name === "instructions_and_notes"
                  ? "pfu-instruction-and-notes"
                  : "")
              }
            >
              <CustomCreatableMultiSelect
                inputLabel={data?.inputLabel}
                options={data?.options}
                menuIsOpen={data?.menuIsOpen}
                value={data?.value}
                name={data?.name}
                handleSearch={handleSearch}
                handleSelect={handleSelect}
                handleOnChange={handleOnChange}
                maxApiCall={maxApiCall}
                setPageNo={setPageNo}
                pageNo={pageNo}
                maxLength={data?.name === "instructions_and_notes" && 250}
                closeMenu={(name) => {
                  let dup = [...followUp.value];
                  dup &&
                    dup.forEach(
                      (obj) => (obj.menuIsOpen = obj.name === name && false)
                    );
                  handleFollowUp(true, [...dup]);
                }}
                handleCustomInput={handleCustomInput}
                hasCustomSaveButton={data?.hasCustomSaveButton}
                handleSaveCustomData={handleSaveCustomData}
              />

              {data?.name === "instructions_and_notes" &&
                instructionSuggestionArr?.length > 0 &&
                renderSuggestionUI(data?.name)}
            </div>
          ))}
        </div>
      </div>
    );
  };

  //  ==>

  return <div>{suggestedInvestigationAndNotes()}</div>;
};

export default SIView;
